import { render } from "./Contact.vue?vue&type=template&id=43244ba2"
const script = {}

import exportComponent from "E:\\project2\\skin-web\\黑石启示\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__